<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible="visible"
      width="400px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => (backDialogVisible = true)"
      append-to-body
      v-el-dialog-drag
    >
      <!-- :modal-append-to-body="false"
      :modal="false" -->
      <UploadForm ref="uploadForm" :title="title" />
      <span slot="footer">
        <el-button size="small" @click="backDialogVisible = true">
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
        <el-button type="primary" size="small" @click="upload()">
          {{ $l('INDEX.btn_upload') || '上传' }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      append-to-body
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="upload()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UploadForm from './form.vue'
export default {
  components: { UploadForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  data() {
    return { backDialogVisible: false }
  },
  methods: {
    async upload() {
      const data = await this.$refs.uploadForm.upload()
      if (!data) return
      this.$emit('upload', data)
      this.close()
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
